'use client'

import Link from 'next/link'
import ContractModeler from '@/app/components/calculators/ContractModeler'

export default function HookSection() {
  return (
    <section className="bg-[var(--surface-1)] py-16 md:py-24">
      <div className="mx-auto max-w-6xl px-4">
        {/* Section header */}
        <div className="mb-10 max-w-2xl">
          <h2 className="text-3xl font-extrabold tracking-tight text-[var(--text-1)] md:text-4xl">
            Model your next contract before you sign.
          </h2>
          <p className="mt-4 text-lg leading-relaxed text-[var(--text-2)]">
            See your total compensation over the life of a contract — base pay,
            allowances, promotions, bonuses, and special pay included.
          </p>
        </div>

        {/* Live contract modeler */}
        <ContractModeler />

        {/* CTA */}
        <div className="mt-10 text-center">
          <Link
            href="/signup"
            className="inline-flex h-12 items-center justify-center rounded-full bg-blue-600 px-8 text-sm font-semibold text-white shadow-lg shadow-blue-600/30 transition hover:bg-blue-500 hover:shadow-blue-500/40"
          >
            Create a free account to save scenarios
          </Link>
        </div>
      </div>
    </section>
  )
}
